import Repository from '@/api/Repository';
import { GroupHasReportsError } from '../user/erros';

export default {
  returnMockData(today) {
    const data = {
      entries: this.getRandomNumber(),
      exits: this.getRandomNumber(),
      line: [],
    };
    let i = 0;
    for (i = 0; i < 24; i++) {
      data.line.push(this.getRandomNumber());
    }
    return data;
  },

  getRandomNumber() {
    return Math.floor(Math.random() * 100 + 3);
  },
  getTableDataMockup(kek) {
    const days = [
      {
        dayNumber: '2019/07/06',
        data: [],
        total: 0,
      }, {
        dayNumber: '2019/07/07',
        data: [],
        total: 0,
      }, {
        dayNumber: '2019/07/08',
        data: [],
        total: 0,
      }, {
        dayNumber: '2019/07/09',
        data: [],
        total: 0,
      }, {
        dayNumber: '2019/07/10',
        data: [],
        total: 0,
      }, {
        dayNumber: '2019/07/11',
        data: [],
        total: 0,
      }, {
        dayNumber: '2019/07/12',
        data: [],
        total: 0,
      }, {
        dayNumber: '2019/07/13',
        data: [],
        total: 0,
      }, {
        dayNumber: '2019/07/14',
        data: [],
        total: 0,
      }, {
        dayNumber: '2019/07/15',
        data: [],
        total: 0,
      },
    ];
    days.forEach((v) => {
      let i = 0;
      for (i = 0; i < 24; i += 1) {
        const number = this.getRandomNumber();
        v.data[i] = number;
        v.total += number;
      }
    });

    return days;
  },

  getCumulativePredefinedData(token, shopsIDs) {
    return Repository.get(`/report/summary/predefined?shopIds=${shopsIDs}`,
      {
        headers:
          {
            Authorization: token,
          },
      }).then(response => response.data);
  },
  getTableData(token, shopsIDs, dateFrom, dateTo, type) {
    return Repository.get(
      `/report/summary/${type}?shopIds=${shopsIDs}&dateFrom=${dateFrom}&dateTo=${dateTo}`, {
        headers: {
          Authorization: token,
        },
      },
    )
      .then(response => response.data);
  },
  getLiveData(token, pointId, dateFrom, dateTo, type) {
    return Repository.get(
      `/report/signals/live/${type}?pointId=${pointId}&dateFrom=${dateFrom}&dateTo=${dateTo}`, {
        headers: {
          Authorization: token,
        },
      },
    )
      .then(response => response.data);
  },
  getCoverData(token, pointId, dateFrom, dateTo, type) {
    return Repository.get(
      `/report/signals/cover/${type}?pointId=${pointId}&dateFrom=${dateFrom}&dateTo=${dateTo}`, {
        headers: {
          Authorization: token,
        },
      },
    )
      .then(response => response.data);
  },
  getUnitPredefinedData(token, data) {
    return Repository.post(
      '/report/unit/period',
      data,
      {
        headers: {
          Authorization: token,
        },

      },
    )
      .then(response => response.data);
  },
  getUnitTableData(token, data, type) {
    return Repository.post(`/report/unit/${type}`, data, {
      headers: {
        Authorization: token,
      },
    }).then(response => response.data);
  },
  getUnitUnits(token, groupID) {
    return Repository.get(
      `/report/unit/units?groupId=${groupID}`, {
        headers: {
          Authorization: token,
        },
      },
    )
      .then(response => response.data);
  },
  saveReports(token, payload) {
    return Repository.post('/report/automatic', payload, { headers: { Authorization: token } })
      .then(response => response).catch((error) => {
        if (error.response.data.code === 'INTERVALS_REQUIRED') {
          throw new GroupHasReportsError();
        } else {
          throw new Error();
        }
      });
  },
  getAutomaticReports(token) {
    return Repository.get('/report/automatic', { headers: { Authorization: token } }).then(response => response.data);
  },
  deleteAutomaticReport(token, reportId) {
    return Repository.delete(`/report/automatic/${reportId}`, { headers: { Authorization: token } }).then(response => response.data);
  },
  getAnalysisData(token, shopIds, dateFrom, dateTo) {
    return Repository.get(
      `/report/summary/shopsHoursPeriod?shopIds=${shopIds}&dateFrom=${dateFrom}&dateTo=${dateTo}`, {
        headers: {
          Authorization: token,
        },
      },
    )
      .then(response => response.data);
  },
  getBarChartPeriod(token, shopIds, dateFrom, dateTo) {
    return Repository.get(
      `/report/summary/period?shopIds=${shopIds}&dateFrom=${dateFrom}&dateTo=${dateTo}`, {
        headers: {
          Authorization: token,
        },
      },
    )
      .then(response => response.data)
      .catch(e => e.response.message);
  },

  getLineChartUnit(token, payload) {
    return Repository.post(
      '/report/pointsHoursPeriod',
      payload,
      {
        headers: {
          Authorization: token,
        },
      },
    )
      .then(response => response.data);
  },
};
